import { render, staticRenderFns } from "./GoodsCommentList.vue?vue&type=template&id=b6e9794c&scoped=true&lang=pug&"
import script from "./GoodsCommentList.vue?vue&type=script&lang=ts&"
export * from "./GoodsCommentList.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsCommentList.vue?vue&type=style&index=0&id=b6e9794c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e9794c",
  null
  
)

export default component.exports